import { __assign, __extends } from "tslib";
import React from 'react';
import classNames from 'classnames';
import { getColorFromTheme } from '../utils/colors';
import DivCanvas from './DivCanvas';
import { withTheme } from 'styled-components';
/**
 * 进度条最大长度，按照弧度定义
 */
var PROGRESS_MAX_WIDTH = 1.9; // 弧度
/**
 * 进度条长度变化基数
 */
var PROGRESS_WIDTH_DELTA = 0.05;
/**
 * @ReactComponent
 *
 * 进度条组件
 *
 * @class Progress
 * @extends {React.Component<ProgressPropsType, *>}
 */
var Progress = /** @class */ (function (_super) {
    __extends(Progress, _super);
    function Progress() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.progressState = 'expand';
        _this.progressWidth = 0;
        return _this;
    }
    Progress.prototype.componentDidMount = function () {
        var _this = this;
        if (!this.canvas) {
            return;
        }
        this.canvasCtx = this.canvas.getContext('2d');
        if (!this.canvasCtx) {
            return;
        }
        this.canvas.width = this.props.size;
        this.canvas.height = this.props.size;
        this.canvasCtx.strokeStyle = getColorFromTheme(this.props);
        this.canvasCtx.lineWidth = this.props.thickness;
        var draw = function () {
            _this.rafId = requestAnimationFrame(function () {
                _this.draw();
                draw();
            });
        };
        draw();
    };
    Progress.prototype.componentWillUnmount = function () {
        cancelAnimationFrame(this.rafId);
    };
    Progress.prototype.draw = function () {
        var ctx = this.canvasCtx;
        if (this.progressState === 'expand') {
            this.progressWidth += PROGRESS_WIDTH_DELTA;
            if (this.progressWidth > PROGRESS_MAX_WIDTH) {
                this.progressState = 'collapse';
                this.progressWidth -= PROGRESS_WIDTH_DELTA;
            }
        }
        else {
            this.progressWidth -= PROGRESS_WIDTH_DELTA;
            if (this.progressWidth < 0) {
                this.progressState = 'expand';
                this.progressWidth = PROGRESS_WIDTH_DELTA;
            }
        }
        var _a = this.props, size = _a.size, thickness = _a.thickness;
        var centerPoint = { x: size / 2, y: size / 2 };
        ctx.clearRect(0, 0, size, size);
        ctx.beginPath();
        if (this.progressState === 'expand') {
            ctx.arc(centerPoint.x, centerPoint.y, size / 2 - thickness, Math.PI * 0, Math.PI * this.progressWidth);
        }
        else {
            ctx.arc(centerPoint.x, centerPoint.y, size / 2 - thickness, Math.PI * (PROGRESS_MAX_WIDTH - this.progressWidth), Math.PI * PROGRESS_MAX_WIDTH);
        }
        ctx.stroke();
    };
    Progress.prototype.render = function () {
        var _this = this;
        return (React.createElement(DivCanvas, __assign({}, this.props, { className: classNames('sinoui-progress', this.props.className) }),
            React.createElement("canvas", { ref: function (canvas) {
                    _this.canvas = canvas;
                } })));
    };
    Progress.defaultProps = {
        size: 40,
        thickness: 3.6,
        color: 'primary',
    };
    return Progress;
}(React.Component));
export default withTheme(Progress);
//# sourceMappingURL=Progress.js.map